import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import {
  Fade,
  Typography,
  Fab,
  Slide,
  Avatar,
  Divider,
  MenuList,
  MenuItem,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core'
import { BiLeftArrowAlt, BiRightArrowAlt } from 'react-icons/bi'
import { MdVerifiedUser } from 'react-icons/md'
import { RiUserFill } from 'react-icons/ri'
import { AiOutlineUserSwitch } from 'react-icons/ai'
import data from '../../mock_data.js'
import Cookies from 'js-cookie'

const base_url = "https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/"

const CustomDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogTitle-root': {
    backgroundColor: "#2b2b2b"
  },
  '& .MuiDialogContent-root': {
    padding: "1em",
    display: "inline-flex",
    alignItems: "center",
  },
  '& .MuiDialogActions-root': {
    padding: "1em"
  }
}))

const SwitchAccounts = (props) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser")) ? JSON.parse(localStorage.getItem("currentUser"))[0] : {}
  const authorizeOptions = JSON.parse(localStorage.getItem("accounts")) ? JSON.parse(localStorage.getItem("accounts")) : []
  const { open, handleSwitchAccount } = props
  const [openDialog, setOpenDialog] = useState(false)
  const [selectedAccount, setSelectedAccount] = useState("")

  const getNewUser = () => {
    const request = fetch(`${base_url}/user`, {
      headers: {
        token: Cookies.get("token")
      }
    })

    request.then(response => response.json())
    .then(data => {
      localStorage.setItem("currentUser", JSON.stringify(data))
      localStorage.setItem("tabScreens", JSON.stringify(data[0].tableau))
      window.location.reload()
    })
    .catch(error => {console.log(error)})
  }

  const handleOpenDialog = (company) => {
    const newSelection = authorizeOptions.filter(({companyName}) => companyName === company)[0]
    setSelectedAccount(newSelection)
    setOpenDialog(true)
  }

  const handleReAuthorize = () => {
      const {ownerID, companyID} = selectedAccount
      const data = {
        "o" : ownerID,
        "c" : companyID
      }

      if(data.o && data.c) {
        fetch(`${base_url}/authorize`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "token": Cookies.get("token")
          },
          body: JSON.stringify(data)
        })
        .then(response => {
          if(response.ok === true) {
            getNewUser()
          }
        })
        .catch(error => {console.log(error)})
      }
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
  }

  return(
    <div id="switch-menu">
      <Fade in={open} timeout={250} mountOnEnter unmountOnExit>
        <Typography variant="caption" className="back-btn">
          GO BACK
          <Fab size="small" className="fab" onClick={handleSwitchAccount}>
            <BiLeftArrowAlt />
          </Fab>
        </Typography>
      </Fade>
      <br/>

      <div className="switch-menu-content">
        <Slide in={open} timeout={500} direction="right" mountOnEnter unmountOnExit>
          <div className="current-user">
            <Typography variant="caption" style={{opacity: 0.5}}>Currently Viewing:</Typography>
            <div className="description">
              <Avatar className="icon">
                <RiUserFill/>
              </Avatar>
              <div className="user-details">
                <Typography style={{opacity: 0.6, fontSize: "18px"}}>{currentUser.username}</Typography>
                <Typography style={{fontWeight: "bold", fontSize: "13px"}}><span>{currentUser.company ? currentUser.company.toUpperCase() : null}</span></Typography>
              </div>
            </div>
          </div>
        </Slide>

        <Fade in={open} timeout={650} mountOnEnter unmountOnExit>
          <Divider orientation="vertical" style={{minHeight: "350px", backgroundColor: "#c7c7c7"}}/>
        </Fade>

        <Slide in={open} timeout={500} direction="left" mountOnEnter unmountOnExit>
          <div className="users-list">
            <Typography variant="caption" style={{opacity: 0.5}}>Switch View To:</Typography>
            <MenuList className="users-list-menu">
              {authorizeOptions ?
                authorizeOptions.filter(({companyName}) => companyName !== currentUser.company).map(({companyName}, i) => (
                  <MenuItem key={`${companyName}-${i}`} className="selection" onClick={() => handleOpenDialog(companyName)} disableRipple>
                    <Typography variant="caption">{companyName.toUpperCase()}</Typography>
                  </MenuItem>
                ))
              :
                null
              }
            </MenuList>
          </div>
        </Slide>
      </div>

      <CustomDialog
        open={openDialog}
        onClose={handleCloseDialog}
        fullWidth={true}
        maxWidth={"sm"}
        className="dialog"
        PaperProps={{
          style: {
            backgroundColor: "#4f4f4f",
            borderRadius: "10px",
            border: "1px solid rgba(255, 255, 255, 0.5)",
          }
        }}
      >
        <DialogTitle className="salespersons-dialog">
          <Typography variant="caption" style={{fontSize: "15px", fontWeight: "bold", color: "#fff"}}>SWITCH CLIENTS?</Typography>
        </DialogTitle>
        <DialogContent className="dialog-content" style={{display: "flex", justifyContent: "center"}}>
          <Typography style={{fontSize: "18px", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", marginTop: "25px"}}>
            <span>{currentUser.company}</span> <BiRightArrowAlt style={{marginLeft: "15px", marginRight: "15px"}}/> <span>{selectedAccount.companyName}</span>?
          </Typography>
        </DialogContent>
        <DialogActions className="dialog-actions">
          <Button className="dialog-cancel" onClick={handleCloseDialog} disableRipple>Cancel</Button>
          <Button className="dialog-confirm" onClick={handleReAuthorize} disableRipple variant="outlined">Confirm</Button>
        </DialogActions>
      </CustomDialog>
    </div>
  )
}

export default SwitchAccounts
